import React from 'react';
import styled from 'styled-components';

const RequestCard = ({ title, description, icon, color, onClick }) => {
  return (
    <Card onClick={onClick} color={color}>
      <IconContainer color={color}>
        <span>{icon}</span>
      </IconContainer>
      <CardContent>
        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardContent>
    </Card>
  );
};

const Card = styled.div`
  display: flex;
  flex-direction: column;
  background-color: var(--background);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--box-shadow);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, background-color 0.3s;
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  }

  @media (max-width: 576px) {
    border-radius: 12px;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    }
  }
`;

const IconContainer = styled.div`
  background-color: ${props => props.color || '#f5f5f5'};
  padding: 3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3.5rem;

  @media (max-width: 576px) {
    padding: 1.5rem;
    font-size: 2.5rem;
  }
`;

const CardContent = styled.div`
  padding: 1.5rem;

  @media (max-width: 576px) {
    padding: 1rem;
  }
`;

const CardTitle = styled.h3`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--text-dark);

  @media (max-width: 576px) {
    font-size: 1rem;
    margin-bottom: 0.25rem;
  }
`;

const CardDescription = styled.p`
  font-size: 0.875rem;
  color: var(--text-light);
  line-height: 1.5;

  @media (max-width: 576px) {
    font-size: 0.75rem;
    line-height: 1.4;
  }
`;

export default RequestCard;